const useScrollTo = () => {
  /**
   * Scroll to and focus the first input element with an error message
   * @param {Object} errors - Error messages where keys represent input element IDs
   */
  const scrollToFirstError = (errors = {}) => {
    const fieldElement = Object.values(errors)?.[0]?.ref;

    if (fieldElement) {
      if (typeof fieldElement.scrollIntoView === 'function') {
        fieldElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      }

      if (typeof fieldElement.focus === 'function') fieldElement.focus();
    }
  };

  return {
    scrollToFirstError,
  };
};

export default useScrollTo;
